import { RootStateOrAny } from "react-redux"

export const getData = (state: RootStateOrAny) => state.data
export const getWallet = (state: RootStateOrAny) => state.wallet
export const getModal = (state: RootStateOrAny) => state.modal
export const getMenu = (state: RootStateOrAny) => state.menu
export const getTransaction = (state: RootStateOrAny) => state.transaction
